const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, TextControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';

export default function Inspector ({ attributes, setAttributes }) {
  // const { variant, title, cardText, icon } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <ImageControl
          image="icon"
          attributes={attributes}
          setAttributes={setAttributes}
        />
        <br />
      </PanelBody>
    </InspectorControls>
  );
};